// extracted by mini-css-extract-plugin
export var button = "_os-1";
export var container = "_os-0";